<template>
  <div class="demo">
    <h1>{{ msg }} -- {{res.chave}} SUBDEMOPAGE</h1>
  </div>
</template>

<script>


try{
  var _base = require("@/page/_base.vue").default;
}catch(err){
  var _base = require("@/framework/page/_base.vue").default;
}

export default {
  extends: _base,
  data () {
    return {
      msg: 'Demo Page4'
    }
  },

  methods:{
    onInit(){
      this.lazyload = {a:10,b:20};
    }
  },
  mounted(){

  } 
}
</script>

<style scoped>
.demo {
  color: #42b983;
}
</style>
